import React, { useEffect, useState } from 'react';
import { Grid, Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, CircularProgress, Typography, Tooltip, Autocomplete } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { useParams } from 'react-router';
import { useSnackbar } from 'notistack';
import { globalGetService, globalPutService } from '../../../../utils/globalApiServices';
import { editDeliveryConditionApi, getClauseAPi } from "../apiServices"
import { checkApiStatus, getTextFieldRows } from '../../../../utils';
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../../constants';
import { ButtonLoader } from '../../../../shared_elements/components';
import { useSelector } from 'react-redux';
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';


const EditDeliveryCondition = ({ onToggleModal, getResponseBack, editDeliveryCondition }) => {
    const params = useParams();
    const { enqueueSnackbar } = useSnackbar();
    const { leaseBasicDetails} = useSelector((state) => state.leases);
    const [isLoading, setLoading] = useState(false);
    const [data, setData] = useState(editDeliveryCondition?.data);
    const [error, setError] = useState({});
    const [clauseData, setClauseData] = useState([]);
    const [isDropDownLoading, setIsDropDownLoading] = useState(false);
    

    useEffect(()=>{
        getConditionClauseData();
    },[])

    const onRestErrorKey = (key) => {
        setError((prev) => ({ ...prev, [key]: '' }));
    };

    const onFieldChange = (key, value) => {
        setData({ ...data, [key]: value });
        setError((prev) => ({ ...prev, [key]: '' }));
    };
    const validateDate = (value, fieldLabel,required=false) => {
        if (!value && required) return `Please enter valid ${fieldLabel}`;
        if (!value) return "";
        const leaseStartDate = moment(leaseBasicDetails?.start_date);
        const leaseEndDate = moment(leaseBasicDetails?.end_date);
        const date = moment(value);

        if (!date.isValid()) {
            return `Please enter valid ${fieldLabel}`;
        }
        if (!leaseStartDate?.isValid() || !leaseEndDate?.isValid()) {
            return "";
        }
        return date.isBetween(leaseStartDate, leaseEndDate, "day", "[]")
            ? ""
            : `${fieldLabel} must be within the lease period`;
    };
    const getConditionClauseData = () => {
        setIsDropDownLoading(true)
        globalGetService(getClauseAPi(params))
            .then(response => {
                setIsDropDownLoading(false)
                if (checkApiStatus(response)) {
                    let responseClause = [];
                    const data = response?.data.data?.list;
                    data?.map((item) => {
                        responseClause.push({ id: item?.id, name: item?.name })
                    });
                    setClauseData(responseClause || []);
                }
            })
    }

    const onEditDeliveryCondition = () => {
        const validationInputs = {
            actual_delivery_date: validateDate(data?.actual_delivery_date, 'Delivery Date Actual'),
            contractual_delivery_date: validateDate(data?.contractual_delivery_date, 'Delivery Date Contractual',true),
            estimated_delivery_date: validateDate(data?.estimated_delivery_date, 'Delivery Date Estimated'),
            // delivery_location: data?.delivery_location ? "" : "Please enter Delivery Location",
            // delivery_terms: data?.delivery_terms ? "" : "Please enter Terms",
            // delivery_asset_conditions_for_contract_id: data?.delivery_asset_conditions_for_contract_id?.id ? "" : "Please select Clause",
        };

        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            setLoading(true);
            const payload={
                ...data,
                // delivery_asset_conditions_for_contract_id: data?.delivery_asset_conditions_for_contract_id?.id ? data?.delivery_asset_conditions_for_contract_id?.id : null
            }
            if (payload.id) {
            } else {
                const { lessee, lessor, ...cleanedData } = payload
                globalPutService(editDeliveryConditionApi(params), { ...cleanedData, lessee_id: payload?.lessee, lessor_id: payload?.lessor }).then(async (response) => {
                    if (checkApiStatus(response)) {
                        enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        onToggleModal()
                        getResponseBack();
                        setLoading(false);
                        trackActivity('Item Edited', { page_title: `Edit Delivery Condition`, success_msg: response?.data?.message, item_slug: params?.leaseSlug, payload: payload, response: response?.data })
                    } else {
                        setLoading(false);
                        enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
                        trackActivity('Item Edited', { page_title: `Edit Delivery Condition`, error_msg: response?.data?.message, item_id: data?.id, payload: payload, response: response?.data })
                    }
                });
            }
        } else {
            setError(validationInputs);
            trackActivity(`Item Edited`, { page_title: `Edit Delivery Condition`, error_msg: validationInputs, })
        }
    };
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Edit Delivery Condition`, page_type: page_type, })
    }
    return (
        <>
            <Dialog
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        onToggleModal();
                    }
                }}
                disableEscapeKeyDown
                aria-labelledby="customized-dialog-title"
                className="add-lease-dialog"
                maxWidth="md"
                fullWidth
                open={true}
            >
                <DialogTitle sx={{ m: 0, p: 2 }} className='dialog-header'>
                   <Typography className="dialog-header-title">Edit Delivery Condition</Typography>
                </DialogTitle>
                <DialogContent dividers>
                    <Grid container spacing={2}>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Delivery Date Contractual"
                                    required
                                    value={data?.contractual_delivery_date ? moment(data.contractual_delivery_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("contractual_delivery_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("contractual_delivery_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            required: true,
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.contractual_delivery_date || false,
                                            helperText: error.contractual_delivery_date || '',
                                            onFocus: () => onRestErrorKey("contractual_delivery_date")
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("date", null);
                                                onRestErrorKey("date");
                                            }
                                        },
                                    }}
                                     shouldDisableDate={(date) => date.isBefore(moment(leaseBasicDetails?.start_date), 'day') || date.isAfter(moment(leaseBasicDetails?.end_date), 'day')}
                                     shouldDisableMonth={(month) => { const y = month.year(), m = month.month(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year() || (y === s.year() && m < s.month()) || (y === e.year() && m > e.month()); }}
                                     shouldDisableYear={(year) => { const y = year.year(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year(); }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}

                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Delivery Date Actual"
                                    value={data?.actual_delivery_date ? moment(data.actual_delivery_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("actual_delivery_date", data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("actual_delivery_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.actual_delivery_date || false,
                                            helperText: error.actual_delivery_date || '',
                                            onFocus: () => onRestErrorKey("actual_delivery_date")
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("actual_delivery_date", null);
                                                onRestErrorKey("actual_delivery_date");
                                            }
                                        },
                                    }}
                                    shouldDisableDate={(date) => date.isBefore(moment(leaseBasicDetails?.start_date), 'day') || date.isAfter(moment(leaseBasicDetails?.end_date), 'day')}
                                    shouldDisableMonth={(month) => { const y = month.year(), m = month.month(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year() || (y === s.year() && m < s.month()) || (y === e.year() && m > e.month()); }}
                                    shouldDisableYear={(year) => { const y = year.year(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year(); }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}

                                />
                            </LocalizationProvider>
                        </Grid>

                        <Grid size={{ md: 4, xs: 12 }}>
                            <LocalizationProvider dateAdapter={AdapterMoment}>
                                <DatePicker
                                    label="Delivery Date Estimated"
                                    value={data?.estimated_delivery_date ? moment(data.estimated_delivery_date) : null}
                                    onChange={(data) => {
                                        const isValid = moment(data)?.isValid();
                                        onFieldChange("estimated_delivery_date",  data ? moment(data).format(backendDateFormat) : null);
                                        if (isValid) {
                                            onRestErrorKey("estimated_delivery_date");
                                        }
                                    }}
                                    slotProps={{
                                        textField: {
                                            InputLabelProps: { shrink: true },
                                            size: "small",
                                            margin: "normal",
                                            error: error.estimated_delivery_date || false,
                                            helperText: error.estimated_delivery_date || '',
                                            onFocus: () => onRestErrorKey("estimated_delivery_date")
                                        },
                                        field: {
                                            clearable: true,
                                            onClear: () => {
                                                onFieldChange("date", null);
                                                onRestErrorKey("date");
                                            }
                                        },
                                    }}
                                    shouldDisableDate={(date) => date.isBefore(moment(leaseBasicDetails?.start_date), 'day') || date.isAfter(moment(leaseBasicDetails?.end_date), 'day')}
                                    shouldDisableMonth={(month) => { const y = month.year(), m = month.month(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year() || (y === s.year() && m < s.month()) || (y === e.year() && m > e.month()); }}
                                    shouldDisableYear={(year) => { const y = year.year(), s = moment(leaseBasicDetails?.start_date), e = moment(leaseBasicDetails?.end_date); return y < s.year() || y > e.year(); }}
                                    sx={{ width: "100%" }}
                                    format={fieldDateFormat}

                                />
                            </LocalizationProvider>
                        </Grid>
                        <Grid size={{ md: 4, xs: 12 }}>
                            <TextField
                                id="delivery_location"
                                label="Delivery Location"
                                variant="outlined"
                                size="small"
                                margin="normal"
                                readOnly={true}
                                slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 25 } }}
                                value={data?.delivery_location || ""}
                                onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? onFieldChange("delivery_location", e.target?.value.trimStart()) : e.preventDefault()}
                                onFocus={() => onRestErrorKey("delivery_location")}
                                error={Boolean(error.delivery_location)}
                                helperText={error.delivery_location || (data?.delivery_location?.length > 25 ? "Maximum 25 characters allowed" : "")}
                                fullWidth />
                        </Grid>
                        <Grid size={{ md: 12, xs: 12 }}>
                            <TextField
                                id="delivery_remarks"
                                label="Remarks"
                                variant="outlined"
                                readOnly={true}
                                size="small"
                                margin="normal"
                                slotProps={{ inputLabel: { shrink: true }}}
                                sx={{ '& .MuiInputBase-input': { resize: 'vertical', overflow: 'auto' } }}
                                value={data?.delivery_remarks || ""}
                                onChange={(e) => {
                                    onFieldChange("delivery_remarks", e.target.value.trimStart());
                                }}
                                error={Boolean(error.delivery_remarks)}
                                helperText={error.delivery_remarks}
                                fullWidth
                                multiline
                                rows={3}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions className="dialog-action">
                    <Button className="cancel-btn" disabled={isLoading} variant="outlined" size="small" onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Cancel</Button>
                    <Button variant="contained" size="small" className="btn-primary" onClick={() => { handleItemClicked('Save Button'); onEditDeliveryCondition() }}>{isLoading ? <CircularProgress color='inherit' size={25} /> : "SAVE"}</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
export default EditDeliveryCondition;